import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IPartnerResourceContext, PartnerResourceService } from 'src/app/xena-api';
import { FiscalSetupApprovalContextService } from 'src/app/xena-api/controllers/fiscal-setup-approval-context/fiscal-setup-approval-context.service';
import { IFiscalSetupApprovalContext } from 'src/app/xena-api/dtos/fiscal-setup-approval-context';

@Component({
    selector: 'app-fiscal-approval-settings',
    templateUrl: './fiscal-approval-settings.component.html',
    styleUrls: ['./fiscal-approval-settings.component.scss'],
    standalone: false
})
export class FiscalApprovalSettingsComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  open: boolean = true;
  saving: boolean = false;
  partnerResourceContexts: IPartnerResourceContext[] = [];
  fiscalSetupApproval: IFiscalSetupApprovalContext;

  form = this.fb.group({
    vouchersMustBeApproved: [false],
    moveToResourceId: 0,
    addSecondaryResponsible: [false]
  });

  constructor(
    private fiscalSetupApprovalContextService: FiscalSetupApprovalContextService,
    private partnerResourceService: PartnerResourceService,
    private fb: UntypedFormBuilder,
  ) { }

  ngOnInit(): void {
    this.subscriptions = [
      this.partnerResourceService.getForFinance({ forceNoPaging: true, showFormerEmployees: false } )
        .subscribe(data => {
          this.partnerResourceContexts = data.entities.filter(entity => entity.mayBookkeepFinance === true);
        }),
      this.fiscalSetupApprovalContextService.get()
        .subscribe(data => {
          this.fiscalSetupApproval = data;
          this.form.get('vouchersMustBeApproved').setValue(data.vouchersMustBeApproved);
          this.form.get('moveToResourceId').setValue(data.moveToResourceId);
          this.form.get('addSecondaryResponsible').setValue(data.addSecondaryResponsible);
        })
    ]
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  cancel() {
    this.open = false;
  }

  async save() {
    this.saving = true;
    this.fiscalSetupApproval = { ...this.fiscalSetupApproval, ...this.form.value };

    this.fiscalSetupApprovalContextService.put(
      this.fiscalSetupApproval
    ).subscribe(() => {
      this.open = false;
      this.saving = false;
    },
    (error) => {
      this.saving = false;
    });
  }
}
